import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { useEffect, useState } from 'react'

// Layout components
import AuthLayout from '@/components/layouts/AuthLayout'
import DashboardLayout from '@/components/layouts/DashboardLayout'

// Auth pages
import LoginPage from '@/pages/auth/LoginPage'

// Dashboard pages
import DashboardPage from '@/pages/dashboard/DashboardPage'
import UsersPage from '@/pages/users/UsersPage'
import UserDetailPage from '@/pages/users/UserDetailPage'
import CreateUserPage from '@/pages/operators/CreateUserPage'
import OperatorsPage from '@/pages/operators/OperatorsPage'
import OperatorDetailPage from '@/pages/operators/OperatorDetailPage'
import WithdrawalsPage from '@/pages/withdrawals/WithdrawalsPage'
import WithdrawalDetailPage from '@/pages/withdrawals/WithdrawalDetailPage'
import DepositsPage from '@/pages/deposits/DepositsPage'
import DepositDetailPage from '@/pages/deposits/DepositDetailPage'
import TradesPage from '@/pages/trades/TradesPage'
import TradeDetailPage from '@/pages/trades/TradeDetailPage'
import AuditPage from '@/pages/audit/AuditPage'
import ReportsPage from '@/pages/reports/ReportsPage'
import SettingsPage from '@/pages/settings/SettingsPage'
import ParametersPage from '@/pages/parameters/ParametersPage'
import MarketDataPage from '@/pages/market-data/MarketDataPage'
import MyWalletPage from '@/pages/my-wallet/MyWalletPage'
import MyWithdrawalsPage from '@/pages/my-withdrawals/MyWithdrawalsPage'
import MyDepositsPage from '@/pages/my-deposits/MyDepositsPage'
import WalletsManagementPage from '@/pages/wallets/WalletsManagementPage'
import ProfilePage from '@/pages/profile/ProfilePage'

// Error pages
import NotFoundPage from '@/pages/error/NotFoundPage'

function App() {
  const user = useAuthStore((state) => state.user)
  const isLoading = useAuthStore((state) => state.isLoading)
  const initialize = useAuthStore((state) => state.initialize)
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    initialize().then(() => {
      setIsInitialized(true)
    })
  }, [])

  console.log('App render:', { user: !!user, isLoading, isInitialized })

  if (!isInitialized || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center space-y-4">
          <div className="loading-spinner w-8 h-8"></div>
          <p className="text-sm text-gray-500">加载中...</p>
        </div>
      </div>
    )
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/auth/*" element={<AuthLayout />}>
        <Route path="login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </Route>

      {/* Protected routes */}
      {user ? (
        <Route path="/*" element={<DashboardLayout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          
          {/* User management */}
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserDetailPage />} />
          
          {/* Operator management */}
          <Route path="operators" element={<OperatorsPage />} />
          <Route path="operators/create" element={<CreateUserPage />} />
          <Route path="operators/:id" element={<OperatorDetailPage />} />
          
          {/* Withdrawal management */}
          <Route path="withdrawals" element={<WithdrawalsPage />} />
          <Route path="withdrawals/:id" element={<WithdrawalDetailPage />} />
          
          {/* Wallets management (Admin only) */}
          <Route path="wallets" element={<WalletsManagementPage />} />
          
          {/* My Wallet & Withdrawals (Operator only) */}
          <Route path="my-wallet" element={<MyWalletPage />} />
          <Route path="my-deposits" element={<MyDepositsPage />} />
          <Route path="my-withdrawals" element={<MyWithdrawalsPage />} />
          
          {/* Deposit management */}
          <Route path="deposits" element={<DepositsPage />} />
          <Route path="deposits/:id" element={<DepositDetailPage />} />
          
          {/* Trade management */}
          <Route path="trades" element={<TradesPage />} />
          <Route path="trades/:id" element={<TradeDetailPage />} />
          
          {/* Audit and reports */}
          <Route path="audit" element={<AuditPage />} />
          <Route path="reports" element={<ReportsPage />} />
          
          {/* Settings */}
          <Route path="settings" element={<SettingsPage />} />
          
          {/* Parameters */}
          <Route path="parameters" element={<ParametersPage />} />
          
          {/* Market Data */}
          <Route path="market-data" element={<MarketDataPage />} />
          
          {/* Profile */}
          <Route path="profile" element={<ProfilePage />} />
          
          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      ) : (
        <Route path="/*" element={<Navigate to="/auth/login" replace />} />
      )}
    </Routes>
  )
}

export default App